import { render, staticRenderFns } from "./Slip.vue?vue&type=template&id=28e7d328&scoped=true"
import script from "./Slip.vue?vue&type=script&lang=js"
export * from "./Slip.vue?vue&type=script&lang=js"
import style0 from "./Slip.vue?vue&type=style&index=0&id=28e7d328&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e7d328",
  null
  
)

export default component.exports